

export const getWccUrl = wcc => {
  return wcc.friendlyUrl
}
